import React from "react";
import { Trans } from "react-i18next";
import SFUseStyled from "../../hooks/useStyled";
import { SFStack } from "../grid";
import { SFEYSFLogoGreyIcon, SFUndrawNotifyIcon } from "../icons";
import SFTypography from "../typography";
import SFLink from "../link";
import env from "env";

const { styled } = SFUseStyled();

const StyledWrapper = styled(SFStack)(({ theme }) => ({
  height: "100%",
  width: "100%",
}));

const StyledEYLogoIcon = styled(SFEYSFLogoGreyIcon)(({ theme }) => ({
  width: "140px",
  height: "28px",
  marginLeft: theme.spacing(3),
  marginBottom: "20px",
}));

const StyledNotifyIcon = styled(SFUndrawNotifyIcon)(({ theme }) => ({
  width: "171px",
  height: "114px",
  flexShrink: 0,
  marginBottom: "27px",
}));

const LinkText = (props) => (
   
  <SFLink underline="hover" href={`mailto:${props.text}`}>
    {props.text}
  </SFLink>
);

const StyledTypography = styled(SFTypography)(({ theme }) => ({
  textAlign: "center",
  width: "100%",
  maxWidth: "439px",
}));

const SFFatalError = () => {
  return (
    <StyledWrapper alignItems="center" justifyContent="center">
      <SFStack alignItems="center" justifyContent="center" spacing={0}>
        <StyledEYLogoIcon />
        <StyledNotifyIcon />
        <StyledTypography variant="body1" color="grey450">
          <Trans
            i18nKey="fatalSystemErrorScreen.support"
            values={{ supportMail: env.REACT_APP_SUPPORT_EMAIL }}
            components={{ link: <LinkText /> }}
          />
        </StyledTypography>
      </SFStack>
    </StyledWrapper>
  );
};

export default SFFatalError;
